let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4OI9P")).then(() => parcelRequire('8uMOi'));